import React from 'react'
import { CRow, CCol, CListGroupItem, CListGroup, CButton, CCallout, CAlert } from '@coreui/react'

const Provincia = () => {
  return (
    <>
      <p className="negrita titulo-pregunta">INFORMACIÓN GENERAL</p>
      <div className="divider mb-4"></div>
      <div className="mb-4"></div>
      <hr />
      <CRow className="mt-2">
        <CCol xs={12} md={12}>
          <p className="texto-descripcion-l">
            La Provincia de Entre Ríos está ubicada al centro-este de la República Argentina, junto
            a Misiones y Corrientes conforma la Mesopotamia Argentina e integra políticamente junto
            con las Provincias de Córdoba y Santa Fe, la Región Centro.
          </p>
          <p className="texto-descripcion-l">
            El 15 por ciento de su superficie está compuesto por islas y tierras anegadizas por lo
            que se la considera una provincia insular. Está rodeada por los ríos Paraná (al oeste) y
            Uruguay (al este). Limita al norte con la provincia de Corrientes, al este con la
            República Oriental del Uruguay, al sur con la provincia de Buenos Aires y al oeste con
            la de Santa Fe.
          </p>
          <p className="texto-descripcion-l">
            El 13 de diciembre de 1969 se inauguró el Túnel Subfluvial “Raúl Uranga-Carlos Sylvestre
            Begnis”, obra de infraestructura que unió las ciudades de Paraná y Santa Fe y que se
            convirtió en el primer enlace vial que vinculó a la Mesopotamia con el resto del país.
          </p>
        </CCol>
      </CRow>
      <CRow classNameName="align-items-start">
        <CCol xs={12} sm={12} md={6} lg={6}>
          <CAlert className="fondoBeigeER">
            <p className="negrita titulo-pregunta">UBICACIÓN</p>
            <p className="texto-descripcion-l">
              Entre Ríos forma parte de la Mesopotamia Argentina e integra políticamente junto con
              las Provincias de Córdoba y Santa Fe, la Región Centro. Por su posición geográfica
              estratégica, comprende un paso obligado en el eje norte­sur de la República Argentina
              con Brasil y el eje este­oeste comprendido por el Corredor Bioceánico que une Uruguay
              y Chile.
            </p>
            <p className="texto-descripcion-l">
              Con una superficie de 78.781 km², ocupa el 2,83 por ciento del total de la superficie
              del país. Limita al norte con la Provincia de Corrientes, al este con la República
              Oriental del Uruguay, al sur con la Provincia de Buenos Aires y al oeste con la
              Provincia de Santa Fe.
            </p>

            <p className="texto-descripcion-l">
              <div>Superficie: 78. 781 km²</div>
              <div>Altitud: 127.5 msnm</div>
              <div>Longitud: 60° 16′ 51.6″ W</div>
              <div>Latitud: 32° 2′ 51.72″ S</div>
              <p className="texto-descripcion-l mt-4">
                <CButton
                  color="primary"
                  target="_blank"
                  href="https://www.google.com/maps/d/u/0/viewer?mid=13PhB-8ZVqwsjUiDJqQBmMGaC3xdA-19h&ll=-32.12233617657677%2C-59.28071840000001&z=8"
                  alt="Mapa de ubicación de Entre Ríos"
                >
                  Ver Mapa de ubicación de Entre Ríos
                </CButton>
              </p>
            </p>
          </CAlert>
        </CCol>

        <CCol xs={12} sm={12} md={6} lg={6}>
          <CAlert className="fondoBeigeER">
            <p className="negrita titulo-pregunta">POBLACIÓN</p>
            <p className="texto-descripcion-l">
              La provincia cuenta con una población aproximada de 1.236.000 habitantes, lo que la
              convierte en la séptima jurisdicción más poblada del país. En tanto que la densidad de
              población promedio es de 15,77 hab/km² con una tendencia marcada ascendente desde el
              centro del territorio hacia los márgenes de los Ríos Uruguay y Paraná, siendo
              especialmente concentrada en los departamentos Paraná, donde la densidad llega a los
              68,3 hab/km²; y en el departamento Concordia, con 52,2 hab/km².
            </p>

            <CButton
              color="primary"
              target="_blank"
              href="https://sig.indec.gov.ar/censo2010/"
              alt="Link mapa Indec"
            >
              Link mapa Indec
            </CButton>
          </CAlert>
        </CCol>
      </CRow>
      <CRow>
        <CCol xs={12} sm={12} md={12} lg={12}>
          <CAlert className="fondoBeigeER">
            <p className="negrita titulo-pregunta">DIVISIÓN POLÍTICA</p>
            <p className="texto-descripcion-l">
              Entre Ríos está organizada en 17 departamentos, cada uno con su respectiva ciudad
              cabecera. La capital provincial es Paraná, sede de los tres poderes del Estado
              entrerriano. En tanto que la localidad de Concordia, sobre la costa del Río Uruguay,
              es la capital alterna de la provincia.
            </p>
            <p className="texto-descripcion-l">
              Cada uno de los departamentos se encuentra compuesto por municipios. Todo centro de
              población estable de más de 1.500 habitantes dentro del ejido constituye un municipio
              (Ley Nº 10.082), siendo el total de 83 en la provincia.
            </p>
            <p className="texto-descripcion-l">
              Las comunidades cuya población estable legalmente determinada sea entre 400 y 1.500
              habitantes se constituyen en comunas. Existen comunas de primera categoría (más de 700
              habitantes y hasta 1.500), y de segunda categoría (entre 400 y 700), según la Ley Nº
              10.644 sancionada en 2018.
            </p>
            <p className="texto-descripcion-l">
              Los anteriormente llamados centros rurales y Juntas de Gobierno hoy son parte de los
              territorios comunales (DEC. MGJ 110/2019), contando Entre Ríos con un total 53
              comunas: 34 comunas de primera categoría y 19 de segunda categoría, de acuerdo a los
              últimos censos realizados. Mientras que los centros poblacionales con una cantidad
              inferior a los 400 habitantes representan un total de 135.
            </p>
          </CAlert>
        </CCol>
        <div className="mb-4"></div>
        <hr />
        <p className="negrita titulo-pregunta">HISTORIA</p>
        <p className="texto-descripcion-l">
          Los hallazgos arqueológicos sugieren que los primeros pobladores de las tierras
          entrerrianas llegaron hace unos 12.000 años, probablemente desde Brasil, cuando ya se
          había iniciado la transición del Pleistoceno al Holoceno. Estos pobladores de la tradición
          Umbú persistieron en el área hasta hace 8.500 años, cuando desaparecieron sus rastros. La
          provincia volvió a poblarse unos 6.000 años atrás cuando retornó la tradición Umbú y
          apareció la Ivaí.
        </p>
        <p className="texto-descripcion-l">
          Se han localizado sitios arqueológicos prehistóricos sobre la costa del río Paraná
          pertenecientes a la tradición cultural Ribereña Paranaense, en la que se distingue la
          entidad cultural, subtradición o cultura Goya-Malabrigo, datada entre el 2000 y 300 años
          atrás. Por lo que a la llegada de las primeras expediciones españolas las tierras
          entrerrianas estaban habitadas por los pueblos Chaná-Timbúes, que se distinguían por su
          habilidad para la artesanía en la cerámica incisa, tal es así que se los ha identificado
          como los “Ribereños Plásticos” y son considerados como los primeros habitantes originarios
          que trabajaron la madera, el cuero, el hueso y la piedra.
        </p>
        <p className="texto-descripcion-l">
          Sobre la zona ribereña del río Uruguay los sitios arqueológicos corresponden a la
          tradición Paleoindígena, integrada por varias fases que comienzan unos 10.000 a. C.
          También se han encontrado otras culturas en el área como la Umbú (del 6000 al 300 adc),
          Ivaí (del 5000 adc) y la Tupí Guaraní, unos 1.500 antes del presente (correspondiente a
          los grupos guaraníes y/o querandíes). También los pueblos Charrúa y Minuán; hábiles
          cazadores, agricultores y pescadores.
        </p>
        <p className="texto-descripcion-l">
          El primer europeo en divisar el suelo entrerriano fue Francisco del Puerto, superviviente
          de la expedición de Juan Díaz de Solís en 1516. Al llegar la invasión española, entre 1573
          hasta el 1730, se conforma el poblamiento hispanocriollo con la fundación de Santa Fe y
          sus concesiones terreras, y comienza el exterminio de los pueblos originarios a través de
          la encomienda, la reducción, las enfermedades y la guerra por la independencia. Los
          enfrentamientos entre unitorarios y federales durante el siglo XIX dejaron desiertas las
          tierras y recién en la actualidad algunos de los pueblos originarios (principalmente
          charrúas y guaraníes) están recuperando su cultura y tradición.
        </p>
        <p className="texto-descripcion-l">
          Durante el proceso independentista Entre Ríos va a jugar un papel destacado de la mano de
          su caudillo y gobernador Francisco Ramírez. La autonomía de Entre Ríos (1814) es lograda
          luego del combate del Espinillo, cerca de Paraná, cuando pasa a integrar la Liga de los
          Pueblos Libres bajo el liderazgo de José Artigas. Se constituye como provincia y se
          designa a Concepción del Uruguay como su capital.
        </p>
        <p className="texto-descripcion-l">
          Declaró su Independencia en 1815 junto a la Liga de los Pueblos Libres que se opusieron a
          la Declaración de 1816 organizada por Buenos Aires y las provincias unitarias en Tucumán,
          sesionando en la villa de Concepción del Uruguay (o Arroyo de la China) para impulsar la
          organización del país bajo un régimen republicano, con autonomía de las provincias y
          declarando la “independencia de España, de los Borbones y de todo poder extranjero”.
        </p>
        <p className="texto-descripcion-l">
          En febrero de 1820, en la Batalla de Cepeda, el triunfo de Francisco Ramírez y Estanislao
          López sobre Buenos Aires dio origen al Tratado del Pilar, que instauraba un sistema
          federal. Así, Ramírez creó la República de Entre Ríos siendo elegido su Jefe Supremo,
          desapareciendo luego de su muerte en 1821. La Constitución de Entre Ríos fue la primera
          sancionada por una provincia argentina.
        </p>
        <p className="texto-descripcion-l">
          Luego de la batalla de Caseros y la separación del Estado de Buenos Aires de la
          Confederación Argentina liderada por Justo José de Urquiza, se constituyó el Territorio
          Federal de Entre Ríos y desde el 24 de marzo de 1854 Paraná pasó a ser la capital de la
          primera confederación de provincias que existió entre 1831 y 1861, cuando Urquiza fue
          derrotado por Bartolomé Mitre en la batalla de Pavón, que significó el fin del federalismo
          y el inicio del dominio porteño por sobre el resto de las provincias y de los pueblos
          originarios, mayormente eliminados.
        </p>
        <p className="texto-descripcion-l">
          Durante la Confederación Argentina se fundó el Colegio Nacional en Concepción del Uruguay,
          que, junto a la creación de la Escuela Normal de Paraná (1870), marcaron un hito dentro de
          la educación argentina. En 1883 el entonces Gobernador Eduardo Racedo, decidió introducir
          algunas reformas, que incluyeron novedosos avances en derechos humanos y en la
          organización de la educación, que por primera vez se proclamó gratuita, laica y
          obligatoria en el nivel primario.
        </p>
        <p className="texto-descripcion-l">
          Durante la gestión del gobernador Luis Etchevehere (1933) se llevó a cabo una reforma
          política integral considerada de avanzada para su época en materia de derechos sociales,
          ya que instauró el voto femenino, la promoción y el fomento del cooperativismo, las bases
          de un moderno sistema de Servicio Civil (empleo público); en el ámbito judicial se
          estableció la inclusión del “hábeas corpus” y el amparo judicial, además de una importante
          reforma electoral en materia de reelección de gobernadores y mecanismos electivos de los
          intendentes.
        </p>
        <p className="texto-descripcion-l">
          En 2008 quedó sancionada la nueva reforma al texto constitucional, esta vez con la
          necesidad de modernizar la carta magna al contexto del siglo XXI. La Honorable Convención
          Constituyente fue el fruto de un proceso democrático y participativo ejemplar cuyo
          consenso contó con el trabajo de cuarenta y cinco convencionales, representantes de cinco
          bloques políticos, y la ciudadanía mediante la presentación de ciento sesenta y dos
          proyectos de reforma constitucional; constituyéndose así en un antecedente único en las
          reformas provinciales de nuestro país y convirtiendo a la Constitución de la Provincia de
          Entre Ríos en un texto modelo en toda América del Sur.
        </p>
      </CRow>
      <CRow>
        <CCol>
          <div className="callout lineaContenedor01">
            <p className="negrita titulo-pregunta">CÓMO LLEGAR</p>
            <p className="texto-descripcion-l">
              De acuerdo a sus límites geográficos y políticos, se puede llegar a Entre Ríos por
              diversas rutas y pasos fronterizos.
            </p>
            <p className="negrita titulo-pregunta mt-200">PASOS FRONTERIZOS</p>
            <p className="texto-descripcion-l">
              Entre Ríos comunica a la Argentina con la República Oriental del Uruguay por medio de
              once pasos internacionales:
            </p>
            <CListGroup>
              <CListGroupItem>
                1.Puente Internacional Gral. José Gervasio Artigas: Colón - Paysandú (terrestre).
              </CListGroupItem>
              <CListGroupItem>
                2.Puente Internacional Gral. San Martín: Gualeguaychú - Fray Bentos (terrestre).
              </CListGroupItem>
              <CListGroupItem>
                3.Puente Represa Hidroeléctrica Salto Grande: Concordia - Salto (terrestre).
              </CListGroupItem>
              <CListGroupItem>
                4.Puerto Boca del Gualeguaychú - Fray Bentos (fluvial).
              </CListGroupItem>
              <CListGroupItem>5.Puerto Colón - Puerto Paysandú (fluvial).</CListGroupItem>
              <CListGroupItem>6.Puerto Concepción del Uruguay - Paysandú (fluvial).</CListGroupItem>
              <CListGroupItem>7.Puerto Concordia - Salto (fluvial).</CListGroupItem>
              <CListGroupItem>8.Puerto Federación - Villa Constitución (fluvial).</CListGroupItem>
              <CListGroupItem>9.Puerto Luis - Constitución (fluvial).</CListGroupItem>
              <CListGroupItem>10.Puerto Paranacito - Nueva Palmira (fluvial).</CListGroupItem>
              <CListGroupItem>11.Puerto Santa Eloísa - Belén (fluvial).</CListGroupItem>
            </CListGroup>
            <p> &nbsp;</p>
            <CButton
              color="primary"
              target="_blank"
              href="https://www.google.com/maps/d/u/0/viewer?mid=13PhB-8ZVqwsjUiDJqQBmMGaC3xdA-19h&ll=-32.12233617657677%2C-59.28071840000001&z=8"
              alt="Mapa de ubicación de Entre Ríos"
            >
              Ver Mapa de ubicación de Entre Ríos
            </CButton>
            &nbsp;&nbsp;
            <CButton
              color="primary"
              target="_blank"
              href="https://www.argentina.gob.ar/seguridad/pasosinternacionales"
              alt="Link Pasos Fronterizos"
            >
              Link Pasos Fronterizos
            </CButton>
          </div>
          <div className="callout lineaContenedor01">
            <p className="negrita titulo-pregunta">CONECTIVIDAD AÉREA</p>
            <p>
              <b>●Aeropuerto General Justo José de Urquiza</b>, ubicado 10 km al SE de la ciudad de
              Paraná, centraliza el tránsito aerocomercial de la provincia.
              <p>Dirección: Salvador Caputto s/n.</p>
              <p>Teléfono: (+54 0343) 4261672. </p>
            </p>
            <p>
              <b>●Aeródromo Comodoro Pierrestegui</b>, Concordia.
              <p>Dirección: Monseñor Rosch 5800.</p>
              <p>Teléfono: (+ 54 0345) 4251001.</p>
              <p>Correo electrónico: aeropuerto@concordia.gob.ar</p>
            </p>
            <p>
              <b>●Aeropuerto de Gualeguaychú</b>
              <p>Dirección: Urquiza al Oeste s/n y Ruta 14.</p>
              <p>Teléfono: (+ 54 03446) 493028.</p>
            </p>
          </div>
          <div className="callout lineaContenedor01">
            <p className="negrita titulo-pregunta">CONECTIVIDAD FERROVIARIA</p>
            <p>
              Trenes Argentinos presta un servicio regional Paraná –Colonia Avellaneda, de lunes a
              sábado, con dos frecuencias diarias, tanto de ida como de vuelta, con las siguientes
              paradas intermedias: Francisco Ramírez, División de los Andes, Miguel David, Las
              Garzas, Gobernador Parera, Salvador Caputto, Gobernador Maya y Ramón A. Parera.
            </p>
            <p>
              <CButton
                color="primary"
                target="_blank"
                href="https://www.argentina.gob.ar/sites/default/files/parana_-_colonia_avellaneda_2022-05-23_-_web.pdf "
                alt="Consultar horarios y precios"
              >
                Consultar horarios y precios
              </CButton>
            </p>
          </div>
          <div className="callout lineaContenedor01">
            <p className="negrita titulo-pregunta">CONECTIVIDAD FLUVIAL</p>
            <p>
              Entre Ríos cuenta con cuatro puertos dependientes del Instituto Portuario del
              Ministerio de Producción, Turismo y Desarrollo Económico de la provincia.
            </p>
            <p>
              El <b>Puerto de Concepción del Uruguay</b> es un complejo portuario fluvio-marítimo,
              autárquico y de carácter público. Está ubicado sobre el río Uruguay, tiene un calado
              de 25 pies y permite la operación de buques de hasta 225 m de eslora.
            </p>
            <p>
              Dirección: Av. Paysandú 274, Concepción del Uruguay.
              <p>Teléfono: (+ 54 0344) 2422-191.</p>
              <p>Correo electrónico: ipper@entrerios.gov.ar</p>
            </p>
            <p>
              El <b>Puerto Ibicuy</b> está situado sobre el río Paraná, posee un calado natural de
              32 pies, lo que posibilita el atraque de cualquier tipo de buque.
            </p>
            <p>
              Ubicación fluvial: Progresiva del Km 217 - Islas del Ibicuy.
              <p>Dirección: Urquiza 1023 - Paraná</p>
              <p>Teléfono: (+ 54 0343) 4316- 435/ 7.</p>
              <p>Correo electrónico: ipper@entrerios.gov.ar</p>
            </p>
            <p>
              El <b>Puerto Diamante</b>, está ubicado sobre el margen izquierdo del Río Paraná a la
              altura del Km. 533 de la Ruta General de Navegación 60°38´45´´ longitud oeste del
              meridiano de Greenwich y cuenta con un calado de 26 pies. Permite la entrada de buques
              Panamax. Consta con una zona portuaria de 600 metros de largo por 80 metros de ancho
              variable.
            </p>
            <p>
              Dirección: Av. Gral. San Martín s/n, Diamante.
              <p>Teléfono: (+ 54 0343) 4981- 836/ 424.</p>
              <p>Correo electrónico: puertodiamante@entrerios.gov.ar</p>
            </p>
            <p>
              El <b>Puerto La Paz</b>, se encuentra ubicado en el norte de la Provincia de Entre
              Ríos, sobre el margen del río Paraná, a la altura de la boya 757 Puerto La Paz y boya
              758 Puerto Márquez.
            </p>
            <p>Dirección: Av. Rondeau s/n, La Paz. </p>
            <p>Teléfono: (+ 54 03437) 425- 591.</p>
          </div>
          <div className="callout lineaContenedor01">
            <p className="negrita titulo-pregunta">CONECTIVIDAD TERRESTRE</p>
            <p>
              Está garantizada por numerosas rutas provinciales y por las siguientes carreteras
              nacionales:
            </p>
            <CListGroup>
              <CListGroupItem>Ruta Nacional N° 12</CListGroupItem>
              <CListGroupItem>Ruta Nacional N° 14</CListGroupItem>
              <CListGroupItem>Ruta Nacional N° 18</CListGroupItem>
              <CListGroupItem>Ruta Nacional N° 127</CListGroupItem>
              <CListGroupItem>Ruta Nacional N° 130</CListGroupItem>
              <CListGroupItem>Ruta Nacional N° 131</CListGroupItem>
              <CListGroupItem>Ruta Nacional N° 135</CListGroupItem>
              <CListGroupItem>Ruta Nacional N° 136</CListGroupItem>
              <CListGroupItem>Ruta Nacional N° 174</CListGroupItem>
              <CListGroupItem>Ruta Nacional N° A015</CListGroupItem>
            </CListGroup>
            <p> &nbsp;</p>
            <CButton
              color="primary"
              target="_blank"
              href="https://www.argentina.gob.ar/obras-publicas/vialidad-nacional/estado-de-las-rutas"
              alt="Estado de las rutas"
            >
              Consultá el estado de las rutas
            </CButton>
          </div>
        </CCol>
      </CRow>
    </>
  )
}

export default Provincia
